import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { PUBLIC_URLS } from './config/apiConfig';
import './Footer.css';

function Footer() {
  const [programs, setPrograms] = useState([]);
  const [socialMedia, setSocialMedia] = useState({
    facebook: '',
    linkedin: '',
    youtube: '',
    twitter: ''
  });

  useEffect(() => {
    // Fetch programs
    axios.get(PUBLIC_URLS.PROGRAMS)
      .then(response => {
        // Accepts array or { items: [...] }
        if (Array.isArray(response.data)) {
          setPrograms(response.data);
        } else if (Array.isArray(response.data.items)) {
          setPrograms(response.data.items);
        } else if (Array.isArray(response.data.programs)) {
          setPrograms(response.data.programs);
        } else {
          setPrograms([]);
        }
      })
      .catch(() => setPrograms([]));

    // Fetch settings (including social media links)
    axios.get(PUBLIC_URLS.SETTINGS)
      .then(response => {
        if (response.data && response.data.socialMedia) {
          setSocialMedia(response.data.socialMedia);
        }
      })
      .catch(error => {
        console.error('Failed to fetch settings:', error);
        // Keep default empty values
      });
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3>ABOUT BVA</h3>
          <ul>
            <li><Link to="/about">Why BVA</Link></li>
            <li><Link to="/professionals">Professionals</Link></li>
            <li><Link to="/office-bearers">Office Bearers</Link></li>
            <li><Link to="/membership">Membership</Link></li>
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h3>UPCOMING PROGRAMS</h3>
          <ul>
            {programs.length > 0 ? (
              programs.map((program) => (
                <li key={program.id || program._id || program.name}>
                  <Link to={`/programs`}>{program.title || program.name} - {program.speaker_name}</Link>
                </li>
              ))
            ) : (
              <li>No programs available</li>
            )}
          </ul>
        </div>
        
        <div className="footer-column">
          <h3>CONTACT US</h3>
          <p className="contact-label">Office Address:</p>
          <p>522C, 1st D Cross, 15th Main, 3rd Stage, 4th Block, Basaveshwaranagar, Bangalore - 560 079 Karnataka, INDIA</p>
          < br/>
          <p>
            <i className="fas fa-envelope" style={{ marginRight: '8px'}}></i>
            <a href="mailto:info@bangalorevaluers.org" style={{ color: 'inherit', textDecoration: 'none' }}>
              Email: info@bangalorevaluers.org
            </a>
          </p>
          <p>
            <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
            <a href="tel:+918088383543" style={{ color: 'inherit', textDecoration: 'none' }}>
              Admin Phone: 8088383543
            </a>
          </p>
          
          {/* Social Media Links */}
          <div className="social-media-section">
            <h4>Follow Us</h4>
            <div className="social-media-icons">
              {socialMedia.facebook && (
                <a 
                  href={socialMedia.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              )}
              {socialMedia.linkedin && (
                <a 
                  href={socialMedia.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              )}
              {socialMedia.youtube && (
                <a 
                  href={socialMedia.youtube} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              )}
              {socialMedia.twitter && (
                <a 
                  href={socialMedia.twitter} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title="Twitter"
                >
                  <i className="fab fa-twitter"></i>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;